import { DSIcon } from '../../../base';

import styles from './LockRoundedIcon.module.scss';

const LockRoundedIcon = () => {
  return (
    <span className={styles['lock-rounded-icon']}>
      <DSIcon name="lock_closed" />
    </span>
  );
};

export default LockRoundedIcon;
